import { Component, EventEmitter, Input, Output } from '@angular/core'
import { MatDialog } from '@angular/material/dialog'
import { MatSnackBar } from '@angular/material/snack-bar'
import { take } from 'rxjs/operators'
import { ParseService } from 'src/app/parse.service'
import { Objects } from '../../../../../server/src/shared-with-client/object-definitions'
import { ConfirmDialogComponent, ConfirmDialogData, ConfirmDialogResponse } from '../dialog/confirm-dialog/confirm-dialog.component'
import { DialogService } from '../dialog/dialog.service'

@Component({
    selector: 'app-chili-image-delete-button',
    template: ` <button mat-icon-button (click)="markItemAsDeleted()" [disabled]="disabled">
        <mat-icon>close</mat-icon>
    </button>`,
    styleUrls: ['./chili-image-delete-button.component.scss'],
    standalone: false,
})
export class ChiliImageDeleteButtonComponent {
    @Input() imageItem?: { image: Objects.Image.Parse }
    @Output() imageDeleted = new EventEmitter<string>()

    private isDeleting = false

    constructor(
        private parseService: ParseService,
        private snackBar: MatSnackBar,
        private dialog: MatDialog,
        private dialogService: DialogService
    ) {}

    get disabled() {
        if (!this.imageItem) {
            return true
        }
        return this.isDeleting
    }

    async markItemAsDeleted() {
        const establishment = this.imageItem?.image.get('establishment')
        const imageItem = this.imageItem
        try {
            if (!establishment) {
                throw new Error('No Establishment')
            }
            if (!imageItem) {
                throw new Error('No Image Data')
            }
            const imageId = imageItem.image.id

            const data: ConfirmDialogData = {
                title: 'Delete Image',
                message: `Are you sure you want to remove the image from your gallery?`,
                confirmButton: {
                    label: 'Delete',
                    color: 'warn',
                },
            }

            const dialogOptions = this.dialogService.getDialogOptions(data, false)

            const dialog = this.dialog.open<ConfirmDialogComponent, ConfirmDialogData, ConfirmDialogResponse>(ConfirmDialogComponent, dialogOptions)

            await new Promise<void>((resolve, reject) => {
                dialog
                    .afterClosed()
                    .pipe(take(1))
                    .subscribe(async (confirm) => {
                        try {
                            if (!confirm) {
                                resolve()
                                return
                            }

                            this.isDeleting = true
                            await this.parseService.markImageAsDeleted(imageId, establishment?.id)
                            this.imageDeleted.emit(imageId)
                            this.isDeleting = false
                            this.snackBar.open('Image Removed')
                            resolve()
                        } catch (err) {
                            reject(err)
                        }
                    })
            })
        } catch (err) {
            this.snackBar.open('Unable To Remove Image. Please Try Again', undefined, { duration: 5000, panelClass: ['error'] })
            this.isDeleting = false
            this.parseService.reportUIError(err, 'Shared.ChiliImageDeleteButtonComponent.markItemAsDeleted', '')
        }
    }
}
